import { FC, cloneElement, Children, PropsWithChildren, ReactElement } from 'react';

import { isElement } from 'react-is';

import { hiddenRecipe, HiddenVariants } from './Hidden.css';

export const Hidden: FC<PropsWithChildren<HiddenVariants>> = ({ children, above, below }) => {
  const hiddenClassName = hiddenRecipe({ above, below });

  const arrayChildren = Children.toArray(children);
  const hiddenChildren = Children.map(arrayChildren, child => {
    if (isElement(child)) {
      return cloneElement(child as ReactElement<{ className: string }>, {
        className: hiddenClassName,
      });
    }

    return <div className={hiddenClassName}>{child}</div>;
  });

  /**
   * Because of a TS issue (https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20356), we need to wrap the children in a fragment.
   * ESlint doesn't like this. But we do.
   */

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{hiddenChildren}</>;
};
